import React, { Component } from "react";
import PropTypes from "prop-types";
import noop from "lodash/noop";
import RaisedButton from "material-ui/RaisedButton";
import Dialog from "material-ui/Dialog";
import FlatButton from "material-ui/FlatButton";
import TextField from "material-ui/TextField";
import { Formik } from "formik";

class component extends Component {
  constructor(props) {
    super(props);
    this.state = { num: 0 };
  }

  onSubmit(values, other) {
    this.handleClose();
    setTimeout(this.props.onSubmit.bind(this, values), 300);
  }

  handleClose = () => {
    this.props.onClose();
  };

  componentWillReceiveProps(newProps) {
    this.setState(prev => {
      return {
        num: prev.num++
      };
    });
  }

  render() {
    return this.props.hasSubscription ? this.render_hasSubscription() : this.render_noSubscription();
  }

  render_noSubscription() {
    const actions = [
      <FlatButton key="cancel-btn" label="Cancel" primary={true} onClick={this.handleClose.bind(this)} />,
      <FlatButton key="submit-btn" label="Get Subscription" primary={true} href="/shop" />
    ];
    return (
      <Dialog title="Save Pocketmod" actions={actions} modal={false} open={this.props.open} onRequestClose={this.handleClose.bind(this)}>
        <form>
          <p>
            This feature is only available for premium subscribers. Please consider supporting Pocketmod by subscribing today, and unlocking many great
            features, such as the PDF to Pocketmod Converter. Thanks.
          </p>
        </form>
      </Dialog>
    );
  }

  render_hasSubscription() {
    const { name, desc } = this.props;

    const initialValues = {
      name,
      desc
    };

    const num = this.state.num;

    return (
      <Formik
        key="save-mod-dialog"
        enableReinitialize={true}
        initialValues={initialValues}
        onSubmit={this.onSubmit.bind(this)}
        render={renderProps => {
          const { values, errors, touched, handleChange, handleBlur, handleSubmit, isSubmitting, setFieldValue } = renderProps;
          const actions = [
            <FlatButton key="cancel-btn" label="Cancel" primary={true} onClick={this.handleClose.bind(this)} />,
            <FlatButton key="submit-btn" label="Save" primary={true} onClick={handleSubmit} />
          ];
          return (
            <Dialog title="Save Pocketmod" actions={actions} modal={false} open={this.props.open} onRequestClose={this.handleClose.bind(this)}>
              <form onSubmit={handleSubmit}>
                <TextField id="text-field-name" floatingLabelText="Pocketmod Name" fullWidth={true} name="name" value={values.name} onChange={handleChange} />
                <TextField
                  id="text-field-desc"
                  floatingLabelText="Description"
                  fullWidth={true}
                  name="desc"
                  value={values.desc}
                  multiLine={true}
                  onChange={handleChange}
                />
              </form>
            </Dialog>
          );
        }}
      />
    );
  }
}

component.propTypes = {
  onSubmit: PropTypes.func,
  hasSubscription: PropTypes.bool,
  onClose: PropTypes.func,
  name: PropTypes.string,
  desc: PropTypes.string,
  open: PropTypes.bool
};

component.defaultProps = {
  onSubmit: noop,
  hasSubscription: false,
  onClose: noop,
  name: undefined,
  desc: undefined,
  open: true
};

export default component;



// WEBPACK FOOTER //
// ./src/components/ui/SavePocketmodDialog.js